import { render } from "./SaConfirmModal.vue?vue&type=template&id=63d84de3&scoped=true"
import script from "./SaConfirmModal.vue?vue&type=script&lang=js"
export * from "./SaConfirmModal.vue?vue&type=script&lang=js"

import "./SaConfirmModal.vue?vue&type=style&index=0&id=63d84de3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d84de3"]])

export default __exports__